import React from "react";
import { STATUS_TONE_CLASS, statusTone } from "../../lib/format";

/** Register status pill. Colour always encodes the same four states. */
export function StatusBadge({ status }) {
  if (!status) return <span className="text-ink-300">—</span>;
  return (
    <span
      className={`inline-block whitespace-nowrap rounded border px-2 py-0.5 text-micro font-semibold ${
        STATUS_TONE_CLASS[statusTone(status)]
      }`}
    >
      {status}
    </span>
  );
}

/** Neutral count / meta chip. */
export function Chip({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded border border-ink-200 bg-white px-2 py-0.5 text-micro font-medium text-ink-600 ${className}`}
    >
      {children}
    </span>
  );
}
